import { render, staticRenderFns } from "./GameFlashCards.vue?vue&type=template&id=67697295&"
import script from "./GameFlashCards.vue?vue&type=script&lang=js&"
export * from "./GameFlashCards.vue?vue&type=script&lang=js&"
import style0 from "./GameFlashCards.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})


/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67697295')) {
      api.createRecord('67697295', component.options)
    } else {
      api.reload('67697295', component.options)
    }
    module.hot.accept("./GameFlashCards.vue?vue&type=template&id=67697295&", function () {
      api.rerender('67697295', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GameFlashCards.vue"
export default component.exports